



















































































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import "moment-timezone";
import moment from "moment";
import FileUpload from "vue-upload-component";
import { FileUploadRequest } from "@/employer/types";
import { useEmployerPayrollStore } from "@/employer/store/employerPayroll";

@Component({
  components: {
    FileUpload
  }
})
export default class ManageFundingFile extends Vue {
  @Prop([String, Array])
  allowedFileType: string | string[];
  @Prop({ default: false })
  allowsPriorYear: boolean;
  @Prop({ default: false })
  allowsNextYear: boolean;
  @Prop()
  uploadFunction: (request: FileUploadRequest) => Promise<any>;
  @Prop()
  isDisabled: boolean;

  employerPayrollStore = useEmployerPayrollStore();

  fileKey = 0;
  fileName = null;
  effectiveYear = moment().year();

  uploadErrors = [];

  get effectiveYears (): number[] {
    if (this.isBeforePriorYearCutOff) {
      return [moment().year(), moment().year() - 1];
    }

    if (this.displayNextYearSelectOption) {
      return [moment().year(), moment().year() + 1];
    }

    return [];
  }

  get displayEffectiveYearDropdown (): boolean {
    return !!this.effectiveYears.length;
  }

  get isBeforePriorYearCutOff (): boolean {
    if (this.allowsPriorYear && !this.displayNextYearSelectOption) {
      return this.employerPayrollStore.isBeforePriorYearCutOff;
    }

    return false;
  }

  get displayNextYearSelectOption (): boolean {
    if (this.allowsNextYear) {
      return this.employerPayrollStore.isInNextYearProcessDateWindow;
    }

    return false;
  }

  get allowedFileTypeRegex (): string {
    return Array.isArray(this.allowedFileType) ? this.allowedFileType.join("|") : this.allowedFileType;
  }

  mounted () {
    if (this.allowsPriorYear) {
      this.employerPayrollStore.getPriorYearInfo();
    }
    if (this.allowsNextYear) {
      this.employerPayrollStore.getNextYearInfo();
    }
  }

  inputFilter (newFile, oldFile, prevent) {
    this.clearErrors();
    if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
      if (this.allowedFileType) {
        const regex = new RegExp(`.(${this.allowedFileTypeRegex})$`, "i");
        if (!regex.test(newFile.name)) {
          this.uploadErrors.push("File type not allowed. only " + this.allowedFileType + " type files are allowed");
          this.fileName = null;
          return prevent();
        }
      } else {
        this.fileName = newFile.name;
      }
    }
  }

  get fileNameDisplay (): string {
    return this.fileName ? this.fileName : "No file selected";
  }

  refreshFileUpload () {
    this.fileName = null;
    this.$parent.$parent.$emit("refreshFileUpload", true);
  }

  uploadFile (files) {
    if (!files) {
      return;
    }

    let effectiveYear: number | null = (this.isBeforePriorYearCutOff || this.displayNextYearSelectOption) ?
      this.effectiveYear : moment().year();

    if (effectiveYear === moment().year()) {
      effectiveYear = null;
    }

    this.uploadFunction({
      effectiveYear,
      file: (document.getElementById("file") as any).files[0]
      })
    .then(() => this.refreshFileUpload());
  }

  clearErrors () {
    this.uploadErrors = [];
  }

  get disableUpload () {
    return this.isDisabled;
  }
}
